const ecommEndpoints = {
  //account
  login: () => "/commercial/ecommerce/V1/integration/customer/token",
  extendToken: () => "/users/V1/customers/me/tokenValidate",
  forgotPassword: () => "/commercial/ecommerce/V1/customers/password",
  resetPassword: () => "/commercial/ecommerce/V1/customers/resetPassword",
  resetPasswordOffline: () => "/users/V1/customers/resetPasswordOffline",
  resetPasswordTokenValidate: () => "/commercial/ecommerce/V1/customers/validateResetToken",
  newPasswordLinkRequest: () =>
    "/commercial/ecommerce/V1/customers/passwordOffline",
  register: () => "/users/customers/V2",
  logout: () => "/commercial/ecommerce/V1/integration/customer/revoke",
  //globalcontent
  getGlobalContent: () => "/commercial/drupal/cms/content/globalcontent",
  // account summary help section timming details
  getWorkingHours: () => "/content/getworkinghourscontent",

  //Custome Summary details
  getCustomerDetails: (customerId) => `/V1/customers/${customerId}`,

  //account details
  getAccountDetails: () => "/commercial/account/GetCustomerDetail",

  //customer Support
  customerSupportInfo: () => "/emails/sendemail",
  privacyRequest: () => "/emails/ccpasendmail",
  cancelRequest: () => "/emails/CancelSalesAgreement",

  //customer service
  customerService: () => "/party/leadportal/processor/insert/general/json",

  //Reschedule
  reschedule: () => "/servicerescheduling/reschedule",

  //compare Plans
  comparePlansInfo: () => "/ecommerce/V1/compareplans",

  //branch products and megamenu plans and services
  getBranchProducts: () => "/plansandproducts/V1/branchProducts",

  //accountSettings
  linkCustomerNumber: () => "/users/V1/customers/customerNumber",
  removeCustomerNumber: () => "/users/V1/customers/delete/customerNumber",
  getCustomerSummary: () => "/commercial/ecommerce/map/getmultiplecustomersummary",
  changePassword: () => "/commercial/ecommerce/V1/customers/me/password",
  updateBillingInfo: () => "/billing/maintain_party_address",
  monthlyBilling: () => "/customers/monthlyBilling",
  paymentMethods: () => "/commercial/paymentmethods/getpaymentmethods",
  deleteMethods: () => "/commercial/paymentmethods/delete_autopay",
  paymentsHistory: () => "/commercial/paymentshistory/paymentshistory",
  myDocuments: (identificationToken) =>
    `/party/OnBridge/OnBridge/DocumentList/GetDocumentListByIdentificationtoken/SMT005/${identificationToken}`,
  //accountSettings-communication
  getPreferences: () => "/commercial/RtvCustPref_Ver3",
  updatePreferences: () => "/CustPreference_Ver3",
  oneTimePayment: () => "/onetime/make_payment_ver3",
  featureControl: () => "/requesthelpfeature/FeatureControl",
  featureControlNew: () => "/commercial/mission/FeatureControl",
  // oprationHours:() => '/hours/cms/GetContent',
  oprationHours: () => "/incontact/cms/GetContentIncontact",
  prePayPayment: () => "/logicapp-prepayenroll/manual/paths/invoke",
  prePayPaymentV2: () => "/commercial/ecommerce/V1/commercial/OTpayment",
  authorizationAndOTPayment: () => `/commercial/ecommerce/card/V1/OTpayment`,
  prePayOTPaymentEnabled: () => "/commercial/ecommerce/V1/OTpaymentEnable",
  existingCardPrePayAuthorzation: () => "/pre/v3/authorization",
  OTpaymentAuthorization: () =>
    "/ecommerce/V1/OTpayment/missing-authorize-total",
  OTpaymentStatus: () => "/commercial/ecommerce/V1/commercial/OTpayment/status",
  //product
  productDetails: (sku) => `/V1/integration/admin/token/${sku}`,
  categories: () => "/V1/categories",

  //checkout
  phoneValidation: (phone) => `/party/twilio/v1/PhoneNumbers/${phone}`,

  //newsroom
  newsroomMediaAssets: () => "/emails/mediaAssetsSendMail",
  newsroomMediaInquiries: () => "/emails/mediainquiriessendmail",
  //service details
  serviceDetails: () => "/commercial/account/GetCustomerDetail_ver7",
  scheduleNow: () => `/servicerescheduling/schedulenow`,
  scheduleConfirmDate: () => `/servicerescheduling/confirmdate`,
  rescheduleDetails: () =>
    "/commercial/fetchservicedetails/rescheduledetails_ver2",
  fetchMyServiceSummary: () => "/Process/ProcessCustomer",
  addCustomerFeedback: () => "/serviceratings/addCustomerFeedback_ver2",

  //Add Payment Method
  addPaymentMethod: () => "/commercial/paymentmethods/add_autopay",

  changePaymentMethod: () => "/commercial/paymentmethods/change_autopay",

  getSqftDetails: () => "/propertydetails/GetPropertySQFTByAddress",

  getSalesAgreement: () => "/getSalesAgreement/GetSalesAgreement",

  getProductDetails: (branchId, stateId, zipcode, url_token) =>
    `/plansandproducts/V1/productServices?branchId=${branchId}&stateId=${stateId}&zip=${zipcode}&url_token=${url_token}&pdp=true`,
  getPlanServiceCounts: (branchId, stateId, zipcode) =>
    `/ecommerce/V1/AllProductServices/${branchId}/${stateId}/${zipcode}`,

  //payment Plans
  paymentPlans: () => "/cartsummary/V1/carts/createCartSummary",

  paymentPlansGuest: (quoteId) =>
    `/cartsummary/V1/guest-carts/${quoteId}/createCartSummary`,

  //payment Info
  paymentInfo: () => "/Createorder/V2/carts/createOrder",

  paymentInfoGuest: (quoteId) =>
    `/Createorder/V2/guest-carts/${quoteId}/createOrder`,

  yourQuote: () => "/exploreservices/V1/carts/getNbsServices",

  yourQuoteGuest: () => "/exploreservices/V1/products/getNbsServices",

  yourPaymentGuest: () => "/exploreservices/V1/guest-carts/updateGetNbs",

  //listen360
  listen360: () => "/party/listen360/getsurveyurl",

  //captcha key
  getCaptchaSiteKey: () => "/account/CaptchaKey",
  captchaSiteVerify: (secretKey, userKey) =>
    `/google/recaptcha/api/siteverify?secret=${secretKey}&response=${userKey}`,

  //glympseReschedule
  getGlympseRescheduleDetails: () =>
    "/fetchservicedetails/rescheduledetailsdaterange_glympse",
  getGlympseRescheduleDetails_Dates: () =>
    "/fetchservicedetails/rescheduledetails_glympse",
  getPreferencesGlympse: () => "/RtvCustPref_Ver3_glympse",
  glympseReschedule: () => "/servicerescheduling/reschedule_glympse",
  getClimateAndSoil: (zipcode) => `/usercontent/getclimateandsoil/${zipcode}`,
  getproductServices: (sku) =>
    `/exploreservices/V1/guest-carts/getproductServices?sku=${sku}`,

  getReviewsServicePlan: (version, labelIds, limit, offsetvalue) =>
    `/yext/reviews?v=${version}&labelIds=${labelIds}&limit=${limit}&offset=${offsetvalue}`,
  getReviewsServiceZip: (version, limit, offsetvalue, locationIds) =>
    `/yext/reviews?v=${version}&limit=${limit}&offset=${offsetvalue}&locationIds=${locationIds}`,
  //loyalty api
  loyaltyUser: (user) => `/loyalty/users/${user}`,

  loyaltyPoint: (user) => `/loyalty/points/${user}`,
  loyaltyUserActivity: (user, pagecount) =>
    `/loyalty/users/${user}/activity?page=${pagecount}`,
  loyaltyCreateUser: () => `/loyalty/users`,
  loyaltyAuthorizationToken: () => `user/cms/content/loyalty/postjwttoken`,
  loyaltyEarnBonusPoints: () => `/loyalty/actions?page=all`,
  loyaltyRedeemPoints: () => `/loyalty/points`,
  loyaltyrewards: (custNum) => `/loyalty/users/${custNum}/reward`,
  loyaltyOrders: () => `/loyalty/orders`,
  loyaltyRedemption: (custNum) => `mission/${custNum}/loyaltyredemption`,
  loyaltyGetOrderStatus: () => `Createorder/V1/guest-carts/orderStatusByCustNo`,

  //checkout new12
  CreateLawnRequest: () => `lawn/Createrequest`,
  ExtractLawnRequest: (requestid) => `lawn/getoutputofrequest/${requestid}`,
  StatusRequest: (requestid) => `lawn/getrequeststatus/${requestid}`,
  // Acuweather API
  weatherLocationInfo: (zipcode) =>
    `party/accuweather/locations/v1/postalcodes/US/search?q=${zipcode}`,
  weatherInfo: (locationCode) =>
    `party/accuweather/currentconditions/v1/${locationCode}`,

  kickoutLog: () => "/user/cms/content/kickoutlogs",
  loyaltyReferralUserInformation: () => `Referral/userinformation`,
  loyaltyReferralHistory: (custNum) => `/mission/referralhistory/${custNum}`,
  loyaltyReferalInfo: () => `Referral/getreferralinfo`,
  addressCleansed: () => `mission/addresshasinstallmentbilling`,
  loyaltyConfrimEmail: (personalInvite) =>
    `mission/friendmail/${personalInvite}`,
  // Products and services drupal api
  getProductServiceDetails: (url_token) =>
    `/data/ReadProductData?sku_id=${url_token}`,
  customerSummary: () => `/commercial/account/CustomerSummary`,
  cancelReason: () => "/users/V1/CancelReason",
  accountDeletionRequest: () => `emails/accountdeletion`,
  cancelReasonStates: () => "/users/V1/CancelReasonStates",
  cancelSalesAgreement: (salesAgrNum) =>
    `mission/${salesAgrNum}/cancelsalesagreement`,
  cancelSalesAgreementNew: (salesAgrNum) =>
    `/commercial/cancelagreement/salesagreement/${salesAgrNum}/cancel`,
  addCustomerEmail: (custNum) => `mission/maintainemailaddress/${custNum}`,
  getCustomerEmail: (custNum) => `mission/GetEmailAddress/${custNum}`,
  lawnCareModule: (url_token) =>
    `/ecommerce/V1/LawnPage?url_token=${url_token}`,
  polygonPost: () => `ecommerce/V1/Polygonpost`,
  // endpoints for edit and delete card
  getChargeAccounts: (custNum) =>
    `/mission/customer/${custNum}/rtvchargeaccounts`,
  editCardSubmitRequest: (custNum) =>
    `/commercial/mission/customer/${custNum}/chargeaccount`,

  switchDiscounts: () => `ecommerce/V1/SwitchDiscountsCms`,
  experianAddressClient: (query, country, take) =>
    `experian/capture/address/v2/search?query=${query}&country=${country}&take=${take}`,
  pauseSalesAgreement: (salesAgrNum) => `/account/pauseservice/${salesAgrNum}`,
  salesHours: () => `/commercial/ecommerce/V1/salesHours`,
  customerLookup: () => "/lookup/customerinfo",
  guestCheckoutCustomerDetail: () => "account/guest/GetCustomerDetail",
  guestCustomerSummary: () => "account/guest/CustomerSummary",
  guestEasyPayEnroll: () => `/mission/customer/chargeaccount2`,

  getPropertyMeasurements: (salesAgrNum) =>
    `commercial/measurement/getpropertymeasurement/${salesAgrNum}`,
  //New Program Names API
  programNames: () => `/ecommerce/V1/programNames`,
  postAnalytics: () => `/analytics/insertData`,
  getQuestions: () => `/ecommerce/V1/questionnaire/questions`,

  getPropertyMeasurements: (salesAgrNum) =>
    `/commercial/measurement/getpropertymeasurement/${salesAgrNum}`,
  addressValidation: () => `mission/addresscheck`,
  getAppointments: (zipcode) => `appointment/schedule?postalcode=${zipcode}`,
  getShowSchedule: () => `appointment/GetShowSchedule`,
  saveUserInformation: () => `appointment/SaveUserInformation`,
  saveAppointments: () => `appointment/BookCommercialAppointment`,
  serviceEmail: () => `emails/InternalEmailService`,
  savePropertyInfo: () => `accountdata/updatepropertyInfo`,
  mediainquiriessendmail: () => `emails/mediainquiriessendmail`,
  exploreplans: (branchNumber, regionCode, zip) => `/ecommerce/V1/exploreplans?branch=${branchNumber}&state=${regionCode}&zip=${zip}`,
  redirectConfig: () => `json/sites/default/files/json_data/redirect-rules.json`,
  getIpAddress: () => `/content/GetClientIpAddress?timestamp=${new Date().getTime()}`,
  missionOutageFlag: () => `/service/outageflag`,
};

export default ecommEndpoints;
